import { render } from "./LicenseBrand.vue?vue&type=template&id=51f3713b"
import script from "./LicenseBrand.vue?vue&type=script&lang=js"
export * from "./LicenseBrand.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__